<template>
  <div id='catalog'>
    
    <v-card>
      <v-card-title>
        Wholesale Catalog
        <div class="flex-grow-1" />
        <v-text-field
          v-model="catalogSearch"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
    
      <v-data-table
        :headers="headers"
        :items="allProducts"
        :search="catalogSearch"
        item-key="code"
        group-by="type"
        class="elevation-1"
        @click:row="handleClickProduct($event)"
      >

        <!-- Adds a mini image into the table -->
        <template v-slot:item.icon="{ item }">
         <v-avatar>
            <img :src="item.image_url" alt="image">
          </v-avatar>
        </template>

        <!-- Adds a mini image into the table -->
        <template v-slot:item.actions="{ item }">
         <v-btn rounded color='secondary'>
           View
         </v-btn>
        </template>
         
      </v-data-table>
    </v-card>

    <ProductView 
      :debug="debug" 
      :item="selectedProduct" 
      :opened.sync="viewProduct" 
      :setChoices="[]" 
      :setQuantity="0" 
      @close="viewProduct = false" 
      @status="viewProduct = $event"
      @update="addProduct($event)" 
    ></ProductView>
  </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { firebase } from '@/utils/firebase'

export default {
  name: 'catalog',
  data () {
      return {
        catalogSearch: null,
        viewProduct: false,
        selectedProduct: null,
        headers: [
          { text: '', value:'icon'},
          { text: 'Title', value: 'title' },
          { text: 'Description', value: 'description' },
          { text: 'Tags', value: 'tags'},
          { text: 'Type', value: 'type' },
          { text: 'WholeSale Price', value: 'wholesale_price_str' },
          { text: '', value: 'actions' },
        ]
          
      }
  },
  mounted() {
  
  },
  computed: {
    ...mapGetters({
      debug: 'getDebug',
      loading: 'getLoading',
      allProducts: 'getAllProducts',
      myProducts: 'getThisOrder'
    }),
  },
  methods: {
    async handleClickProduct(item) {
      let payload = item
      let variant = item.variant ? item.variant : item.type
      payload['variants'] = await this.$store.dispatch('getVariants', variant)
      this.selectedProduct = payload 
      console.log('selectedProduct in calalog:', this.selectedProduct)
      this.viewProduct = true
    },
    addProduct(item) {
      if(this.debug) console.log(item)
      this.$store.dispatch('addProduct', item)
      this.viewProduct = false
    },
    closeProduct() {
      this.viewProduct = false
    },
    resetProduct() {
      this.selectedProduct = null
    }
  },
  watch: {
    'viewProduct': {
      handler: function(newVal, oldVal) {
        if(newVal != oldVal && newVal == false) {
          this.resetProduct()
        }
      },
    },
  }
}
</script>

<style scoped>

#catalog {
  width: 100%;
  height: auto;
  min-height: 500px;
  align-content: center;
  padding-left: auto;
  padding-right: auto;
  position: relative;
}

#product-dialog {
  width: 90%;
  max-width: 500px;
}

</style>



